import React, { PureComponent } from 'react';
import { getSignalDelay } from '@/services/Sierra/results';
import { connect } from 'react-redux';
import makeCancelable from '@/services/api/makeCancelable';
import DelayComp, { sortDelayData } from '../components/Delay';
import { ResultData } from '@/services/Sierra';
import { COMP_REPEATER } from '../../../../constants/componentType';

class DelayResult extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      delayData: [],
    }
  }

  componentDidMount() {
    const { verificationSubId, verificationId } = this.props;
    if (verificationId && verificationSubId) {
      this.getDelay()
    }
  }

  componentDidUpdate(prevProps) {
    const { verificationSubId, verificationId } = this.props;
    if (verificationId !== prevProps.verificationId && verificationSubId) {
      this.getDelay()
    }
  }

  getDelay = async () => {
    const { verificationSubId, currentProjectId, verificationId, signalNameObj } = this.props;
    let designs = [];
    ResultData.getVerificationJsonPromise(verificationSubId, verificationId, currentProjectId).then(res => {
      if (res) {
        const isHSpice = res && res.Config && res.Config.simulate === "HSPICE";
        let currentInterfaces = ResultData.getInterfaces();
        let hasRepeater = false;
        currentInterfaces.forEach(item => {
          designs.push({
            id: item.pcbId,
            name: item.pcb
          });
          if (isHSpice && item.content && item.content.components && item.content.components.find(it => it.type === COMP_REPEATER)) {
            hasRepeater = true;
          }
        })
        const promise = getSignalDelay({ verificationId, designs, projectId: currentProjectId, verificationSubId })
        this.cancelable = makeCancelable(promise);
        this.cancelable.promise.then(
          (response) => {
            const delay = response;

            this.setState({
              delayData: sortDelayData(delay, currentInterfaces, signalNameObj),
              errorMsg: delay && delay.length ? "" : "HSPICE does not support calculating delay results with repeater components."
            })
          },
          (error) => {
            this.setState({
              delayData: [],
              errorMsg: hasRepeater ? "HSPICE does not support calculating delay results with repeater components." : null
            })
            console.error(error);
          }
        );
      } else {
        this.setState({
          delayData: [],
          errorMsg: ""
        })
      }
    })
  }

  render() {
    const { delayData, errorMsg } = this.state;
    return DelayComp({ delayData, key: 'Delay', errorMsg });
  }
}

const mapState = (state) => {
  const { project, resultReducer: { resultInfo } } = state.SierraReducer;
  const { currentProjectId } = project;
  const { verificationSubId, verificationId } = resultInfo;
  return {
    verificationId,
    currentProjectId,
    verificationSubId
  }
}

const mapDispatch = (dispatch) => ({
})

export default connect(mapState, mapDispatch)(DelayResult);